import { Outlet, createFileRoute } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/user/_layout/attendance")({
  beforeLoad: () => requireFeature("attendance"),
  component: AttendanceLayout,
});

function AttendanceLayout() {
  return <Outlet />;
}
